import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButtonMenu from 'components/IconButtonMenu';
import RoomRatesEditorSettingsMenuCatering from 'components/RoomRatesEditorSettingsMenuCatering';
import RoomRatesEditorSettingsMenuRooms from 'components/RoomRatesEditorSettingsMenuRooms';

import { RoomRatesEditorSettingsMenu_package$key } from '__generated__/RoomRatesEditorSettingsMenu_package.graphql';
import { RoomRatesEditorSettingsMenu_data$key } from '__generated__/RoomRatesEditorSettingsMenu_data.graphql';

type Props = {
  package: RoomRatesEditorSettingsMenu_package$key;
  data: RoomRatesEditorSettingsMenu_data$key;
};

const RoomRatesEditorSettingsMenu: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment RoomRatesEditorSettingsMenu_package on Package {
        ...RoomRatesEditorSettingsMenuRooms_package
        ...RoomRatesEditorSettingsMenuCatering_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment RoomRatesEditorSettingsMenu_data on Query {
        ...RoomRatesEditorSettingsMenuCatering_data
      }
    `,
    props.data
  );

  return (
    <IconButtonMenu size="small" icon={<SettingsIcon fontSize="small" />}>
      <RoomRatesEditorSettingsMenuRooms package={pack} />
      <RoomRatesEditorSettingsMenuCatering package={pack} data={data} />
    </IconButtonMenu>
  );
};

export default RoomRatesEditorSettingsMenu;
